import { BFE_BASE_URL, ORP_BASE_URL } from "../../GlobalConstant";

const customEventConfig = {
  isEnable: process.env.REACT_APP_ENABLE_KPI === "true",
  eventBaseURL: `${BFE_BASE_URL}${ORP_BASE_URL}`,
  unmaskRequest: "enable",
  channel: process.env.REACT_APP_CHANNEL,
  xCountry: process.env.REACT_APP_X_COUNTRY || "",
  "x-service-id": process.env.REACT_APP_BFE_SERVICE_ID,
  "x-api-version": "1.0.0",
  ...(process.env.REACT_APP_MODE === "UAT" && { "x-api-key": process.env.REACT_APP_BFE_API_KEY })
};

export default customEventConfig;